import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Grid from "@mui/material/Grid2";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import React from "react";
import { useAppSelector } from "@store/hooks";
import RatiosTable from "./RatiosTable";

const name = "Ratios";

const Ratios: React.FC = () => {
    const [checkBoxDay, setCheckBoxDay] = React.useState<boolean>(false);

    const data = useAppSelector(({ state }) => state.UsersStatistics);
    const yesterdaysData = useAppSelector(({ state }) => state.UsersStatisticsYesterday);

    return (
        (<Grid container direction="column" justifyContent="center" alignItems="center" flexBasis="44.5%">
            <Paper elevation={4} sx={(theme) => ({
                padding: theme.spacing(1),
                [theme.breakpoints.up(600 + Number(theme.spacing(3)) * 2)]: {
                    padding: theme.spacing(1),
                    maxWidth: 800
                },
            })}>
                <Grid >
                    <Grid
                        size={{
                            xs: 2,
                            sm: 2
                        }}><FormGroup>
                            <FormControlLabel control={<Checkbox checked={checkBoxDay} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                setCheckBoxDay(event.target.checked);
                            }} />} label="Yesterday" />
                        </FormGroup></Grid>
                    <Grid
                        size={{
                            xs: 12,
                            sm: 12
                        }} sx={{ mt: -1 }}><Typography variant='h5' textAlign="center">{!checkBoxDay ? "Today's" : "Yesterday's"} Stats</Typography></Grid>
                </Grid>
                <RatiosTable data={checkBoxDay ? yesterdaysData : data} />
            </Paper>
        </Grid>)
    );
}

Ratios.displayName = name;

export default React.memo(Ratios);